

<div class="flex-row padding-large gap-none">


    <div class="flex-column flex--align-center">

        <div style="z-index: 1;" class="round-72 border-gray primary-background-A200--radial-gradient position-relative">

            <h4 style="z-index: 1;" class="mat-headline-6  absolute-centered primary-text-700-darkened">
                {{initialsObs | async}}
            </h4>
            
        </div>
    </div>

    <div class="flex-1 flex-column gap-small position-relative">

        <h5  class="mat-headline-6 primary-text-900 padding-standard-left">{{displayObs | async}}</h5>
        <div class="divider"></div>
        <p class="mat-body-2 padding-standard-left">{{emailObs | async}}</p>

        
    </div>
        
</div>

<div class="border-primary-top padding-standard flex-row flex--align-center flex--justify-between">
    
    <ss-language-select 
        [expanded]="false"
    ></ss-language-select>

    <div class="flex-row"> 

        <button mat-stroked-button 
                color="primary"
                (click)="goToUserSettings();userMenuOpenedSubject.next(false)"
        >
            <mat-icon>account_circle</mat-icon>
            <span>{{'ss-entities.user.account' | translate}}</span>

        </button>

        <button mat-stroked-button
                (click)="logout();userMenuOpenedSubject.next(false)"
        >
            <mat-icon>logout</mat-icon>
            <span>{{'ss-auth.logout' | translate}}</span>

        </button>
    </div>
    
</div>
